import { render, staticRenderFns } from "./EducationalOrganization.vue?vue&type=template&id=b11d918c&scoped=true&"
import script from "./EducationalOrganization.vue?vue&type=script&lang=ts&"
export * from "./EducationalOrganization.vue?vue&type=script&lang=ts&"
import style0 from "./EducationalOrganization.vue?vue&type=style&index=0&id=b11d918c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11d918c",
  null
  
)

export default component.exports